import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  ViewTableModule,
} from 'beyond-util';
import { PrihodiPoEmisijamaComponent } from './prihodi-po-emisijama.component';
import { ReportHeaderModule } from '../../../components/report-header/report-header.module';

@NgModule({
  declarations: [PrihodiPoEmisijamaComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    ReportHeaderModule,
  ],
  exports: [PrihodiPoEmisijamaComponent],
  entryComponents: [PrihodiPoEmisijamaComponent],
})
export class PrihodiPoEmisijamaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/prihodi-po-emisijama/prihodi-po-emisijama.module.ts